import { render, staticRenderFns } from "./ItemFile.vue?vue&type=template&id=2cce2f38&"
import script from "./ItemFile.vue?vue&type=script&lang=js&"
export * from "./ItemFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports